import type { NavigationStateRecord } from "../types";

/**
 * Based on completed steps vs total steps.
 * Returns the percentage of completed steps.
 * @deprecated
 */
export function getTotalProgressFromStep(
  step: NavigationStateRecord,
): undefined | number {
  if (!step.steps || step.steps.length === 0) {
    return 0;
  }

  const totalSteps = step.steps.length;
  const completedSteps = step.steps.filter(
    (subStep) => subStep.completed,
  ).length;

  return (completedSteps / totalSteps) * 100;
}
